import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const userManagerPlugin = createPlugin({
  id: 'user-manager',
  routes: {
    root: rootRouteRef,
  },
});

export const UserManagerPage = userManagerPlugin.provide(
  createRoutableExtension({
    name: 'UserManagerPage',
    component: () =>
      import('./components/UserManagerPage').then(m => m.UserManagerPageComponent),
    mountPoint: rootRouteRef,
  }),
);
